export const unifiedStyle = (props) => {
  return {
    'backgroundColor': '#fff',
    'display': 'flex',
    'height': '100%',
    'width': '100%',
    'maxHeight': '100vh',
    'boxSizing': 'border-box',
    'fontFamily': `${props.theme.fontFamily}`,
    'border': props.isFromUniversalMessaging
      ? 'unset'
      : `1px solid ${props.theme.borderColor.primary}`,
    'position': 'relative',
    '*': {
      'boxSizing': 'border-box',
      'fontFamily': `${props.theme.fontFamily}`,
      '::-webkit-scrollbar': {
        width: '8px',
        height: '4px',
      },
      '::-webkit-scrollbar-track': {
        background: '#ffffff00',
      },
      '::-webkit-scrollbar-thumb': {
        'background': '#ccc',
        '&:hover': {
          background: '#aaa',
        },
      },
    },
    // Apply specific styling for mobile view if `isFromUniversalMessaging` is enabled
    ...(props.isFromUniversalMessaging && {
      height: '100vh',
      width: '100%',
    }),
  };
};

export const unifiedSidebarStyle = (state, props) => {
  const sidebarView = state.sidebarview
    ? {
        left: '0',
      }
    : {};

  const mq = [...props.theme.breakPoints];

  return {
    'width': '320px',
    'minWidth': '320px',
    'borderRight': `1px solid ${props.theme.borderColor.primary}`,
    'height': '100%',
    'position': 'relative',
    'display': 'flex',
    'flexDirection': 'column',
    '> .contacts, .chats, .groups, .userinfo': {
      height: '100%',
    },
    [`@media ${mq[0]}`]: {
      position: 'absolute!important',
      left: '-100%',
      top: '0',
      bottom: '0',
      width: '100%!important',
      minWidth: 'unset',
      zIndex: '2',
      backgroundColor: `${props.theme.backgroundColor.white}`,
      transition: 'all .3s ease-out',
      ...sidebarView,
    },
    // Force sidebar behavior as overlay in the 384px mobile view if `isFromUniversalMessaging` is enabled
    ...(props.isFromUniversalMessaging && {
      position: 'absolute',
      left: '-100%',
      top: '0',
      bottom: '0',
      width: '100%',
      minWidth: 'unset',
      zIndex: '2',
      backgroundColor: `${props.theme.backgroundColor.white}`,
      transition: 'all .3s ease-out',
      ...sidebarView,
    }),
  };
};

export const unifiedMainStyle = (state, props) => {
  const mq = [...props.theme.breakPoints];

  return {
    width: 'calc(100% - 320px)',
    height: '100%',
    order: '2',
    display: 'flex',
    flexDirection: 'row',
    [`@media ${mq[1]}, ${mq[2]}`]: {
      width: '100%',
    },
    ...(props.isFromUniversalMessaging && {
      width: '100%',
    }),
  };
};
